import { useEffect, useMemo } from 'react';

// Vidéo de démonstration — sera remplacée par la vidéo officielle (30 à 45 secondes).
const DEMO_VIDEO_URL =
  'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4';

// Sous-titres français provisoires, à remplacer par les sous-titres définitifs
// dès que le texte de la vidéo nous sera fourni.
const SUBTITLES_VTT = `WEBVTT

00:00:00.000 --> 00:00:05.000
Bienvenue sur MEDICACLIC.

00:00:05.000 --> 00:00:11.000
Trouvez un médecin, un laboratoire ou une pharmacie près de chez vous.

00:00:11.000 --> 00:00:18.000
Choisissez une spécialité et un quartier, puis un créneau disponible.

00:00:18.000 --> 00:00:25.000
Votre demande est envoyée directement au praticien.

00:00:25.000 --> 00:00:32.000
Dès qu'il confirme, vous recevez votre rendez-vous en un clic.

00:00:32.000 --> 00:00:40.000
Simple, rapide et gratuit pour les patients.
`;

interface VideoModalProps {
  onClose: () => void;
}

export default function VideoModal({ onClose }: VideoModalProps) {
  // Sous-titres générés côté navigateur (aucun fichier externe requis).
  const subtitleUrl = useMemo(
    () => URL.createObjectURL(new Blob([SUBTITLES_VTT], { type: 'text/vtt' })),
    [],
  );

  useEffect(() => () => URL.revokeObjectURL(subtitleUrl), [subtitleUrl]);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = previousOverflow;
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-foreground-950/90 backdrop-blur-sm px-4 py-8"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="relative w-full max-w-4xl animate-fade-up"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          aria-label="Fermer la vidéo"
          className="absolute -top-12 right-0 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 text-background-50 transition-colors cursor-pointer"
        >
          <i className="ri-close-line text-2xl w-6 h-6 flex items-center justify-center" />
        </button>

        <div className="rounded-xl overflow-hidden border border-background-50/15 bg-black aspect-video">
          <video className="w-full h-full" controls autoPlay playsInline crossOrigin="anonymous">
            <source src={DEMO_VIDEO_URL} type="video/mp4" />
            <track kind="subtitles" src={subtitleUrl} srcLang="fr" label="Français" default />
            Votre navigateur ne prend pas en charge la lecture vidéo.
          </video>
        </div>

        <p className="mt-3 text-center text-xs text-background-200">
          Activez les sous-titres via le bouton « CC » du lecteur.
        </p>
      </div>
    </div>
  );
}